import React from 'react'
import { Box, Container, Grid, Stack, Typography, Link as MuiLink, Divider } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useReduxAuth } from '../contexts/ReduxAuthContext'

const Footer: React.FC = () => {
  const { t } = useTranslation()
  const { authenticated, login } = useReduxAuth()
  const year = new Date().getFullYear()

  return (
    <Box component="footer" sx={{ mt: 2, pt: 3, pb: 4, borderTop: '1px solid', borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Grid container spacing={3} alignItems="flex-start">
          <Grid item xs={12} md={6}>
            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1 }}>Kavithai.de</Typography>
            <Typography variant="body2" color="text.secondary">
              {t('appSubtitle')}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack direction="row" spacing={3} justifyContent={{ xs: 'flex-start', md: 'flex-end' }} alignItems="center">
              <MuiLink component={RouterLink} to="/" underline="hover" color="inherit">{t('nav.home')}</MuiLink>
              <MuiLink component={RouterLink} to="/contact" underline="hover" color="inherit">{t('nav.contact')}</MuiLink>
              {!authenticated && (
                <MuiLink
                  component={RouterLink}
                  to="/login"
                  underline="hover"
                  color="inherit"
                  sx={{ opacity: 0.65, fontSize: '0.85rem', textTransform: 'none' }}
                >
                  {t('nav.login')}
                </MuiLink>
              )}
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />
        <Typography variant="caption" color="text.secondary">© {year} Kavithai.de — {t('appTitle')}</Typography>
      </Container>
    </Box>
  )
}

export default Footer
